export let results2023 = {
    categories: ["demographics", "fun", "drinking", "medical", "drug_Use"],
    charts: [{
            demographics: {
                Subreddit_activity: {
                    chartOptions: {
                        main: 'Demographics',
                        size: '12',
                        height: "auto",
                        chart: {
                            type: 'column'
                        },
                        xAxis: {
                            categories: [`Active commenter`, `Active poster`, `Active poster & commenter`, `Discord/Chat only`, `Lurker`],
                        },
                        title: {
                            text: "Subreddit activity?"
                        },
                        series: [{
                                name: 'Count',
                                data: [33, 4, 46, 6, 200]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                How_old_are_you__years_: {
                    chartOptions: {
                        main: 'Demographics',
                        size: '12',
                        height: "auto",
                        chart: {
                            type: 'column'
                        },
                        xAxis: {
                            categories: [`18`, `19`, `20`, `21`, `22`, `23`, `24`, `25`, `26`, `27`, `28`, `29`, `30`, `31`, `32`, `33`, `34`, `35`, `36`, `37`, `38`, `39`, `40`, `41`, `42`, `43`, `44`, `45`, `46`, `47`, `48`, `49`, `50`, `51`, `52`, `53`, `54`, `55`, `56`, `57`, `61`],
                        },
                        title: {
                            text: "How old are you? (years)"
                        },
                        series: [{
                                name: 'Count',
                                data: [2, 3, 2, 4, 7, 2, 5, 13, 11, 13, 13, 12, 17, 16, 11, 9, 14, 16, 19, 11, 9, 10, 15, 6, 3, 11, 5, 4, 1, 1, 2, 3, 2, 1, 3, 3, 2, 3, 2, 1, 2]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                Height: {
                    chartOptions: {
                        main: 'Demographics',
                        size: '12',
                        height: "auto",
                        chart: {
                            type: 'column'
                        },
                        xAxis: {
                            categories: [`4' 10" (147 cm)`, `5' (152 cm)`, `5' 1" (155 cm)`, `5' 2" (157 cm)`, `5' 3" (160 cm)`, `5' 4" (162 cm)`, `5' 5" (165 cm)`, `5' 6" (168 cm)`, `5' 7" (170 cm)`, `5' 8" (173 cm)`, `5' 9" (175 cm)`, `5' 10" (178 cm)`, `5' 11" (180 cm)`, `6' (183 cm)`, `6' 1" (185 cm)`, `6' 2" (188 cm)`, `6' 3" (190 cm)`, `6' 4" (193 cm)`, `6' 6" (198 cm)`, `7' or higher (213 cm)`],
                        },
                        title: {
                            text: "Height?"
                        },
                        series: [{
                                name: 'Count',
                                data: [0, 1, 4, 10, 13, 13, 14, 27, 23, 32, 28, 25, 33, 26, 11, 13, 8, 4, 1, 0]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                Gender_identity: {
                    chartOptions: {
                        main: 'Demographics',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`Female`, `Female (Trans)`, `Male`, `Male (Trans)`, `Non-binary`],
                        },
                        title: {
                            text: "Gender identity"
                        },
                        series: [{
                                name: 'Count',
                                data: [101, 4, 171, 3, 10]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                Sexual_Orientation: {
                    chartOptions: {
                        main: 'Demographics',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`Asexual`, `Bisexual`, `Gay`, `Pansexual`, `Queer`, `Straight`],
                        },
                        title: {
                            text: "Sexual Orientation"
                        },
                        series: [{
                                name: 'Count',
                                data: [7, 41, 18, 12, 2, 209]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },

                Which_country_do_you_live_in: {
                    chartOptions: {
                        type: "map",
                        mapChart: "mapChart",
                        class: "map",
                        size: "12",
                        chart: {
                            map: "myMapName"
                        },
                        title: {
                            text: "Which country do you live in?"
                        },
                        subtitle: {
                            text: ""
                        },
                        mapNavigation: {
                            enabled: true,
                            buttonOptions: {
                                alignTo: "spacingBox"
                            }
                        },
                        colorAxis: {
                            min: 0
                        },
                        series: [{
                                name: "Count",
                                states: {
                                    hover: {
                                        color: "#BADA55"
                                    }
                                },
                                dataLabels: {
                                    enabled: true,
                                    format: "{point.name}"
                                },
                                allAreas: false,
                                data: [[`us`, 200], [`au`, 7], [`at`, 1], [`br`, 1], [`bg`, 1], [`ca`, 20], [`hr`, 1], [`dk`, 1], [`eg`, 1], [`ee`, 2], [`fi`, 2], [`fr`, 1], [`de`, 9], [`gr`, 1], [`is`, 2], [`ie`, 1], [`it`, 2], [`jp`, 2], [`lv`, 1], [`nl`, 2], [`nz`, 2], [`pe`, 1], [`pl`, 2], [`qa`, 1], [`ro`, 2], [`sg`, 1], [`se`, 2], [`ch`, 2], [`tr`, 2], [`gb`, 16]]
                            }
                        ]
                    }
                },
                If_you_re_in_the_USA_or_Canada__which_state_or_province_are_you_located_in: {
                    chartOptions: {
                        type: "map",
                        mapChart: "mapChart",
                        class: "map",
                        size: "12",
                        chart: {
                            map: "NaCan"
                        },
                        title: {
                            text: `If you're in the USA or Canada, which state or province are you located in?`
                        },
                        subtitle: {
                            text: ""

                        },
                        mapNavigation: {
                            enabled: true,
                            buttonOptions: {
                                alignTo: "spacingBox"
                            }
                        },
                        colorAxis: {
                            min: 0
                        },
                        series: [{
                                name: "Count",
                                states: {
                                    hover: {
                                        color: "#BADA55"
                                    }
                                },
                                dataLabels: {
                                    enabled: true,
                                    format: "{point.name}"
                                },
                                allAreas: false,
                                data: [[`us-al`, 2], [`us-ak`, 2], [`ca-ab`, 3], [`us-az`, 2], [`us-ar`, 1], [`ca-bc`, 4], [`us-ca`, 11], [`us-co`, 4], [`us-ct`, 3], [`us-fl`, 12], [`us-ga`, 4], [`us-id`, 1], [`us-il`, 5], [`us-in`, 4], [`us-ia`, 3], [`us-ky`, 1], [`us-la`, 1], [`us-me`, 3], [`ca-mb`, 1], [`us-md`, 5], [`us-ma`, 6], [`us-mi`, 8], [`us-mn`, 13], [`us-mo`, 3], [`us-nv`, 1], [`us-nh`, 1], [`us-nj`, 6], [`us-nm`, 2], [`us-ny`, 10], [`us-nc`, 3], [`ca-ns`, 1], [`us-oh`, 6], [`us-ok`, 2], [`ca-on`, 7], [`us-or`, 9], [`us-pa`, 8], [`ca-qc`, 4], [`us-sc`, 1], [`us-sd`, 2], [`us-tn`, 2], [`us-tx`, 9], [`us-ut`, 5], [`us-va`, 5], [`us-wa`, 5], [`us-dc`, 3], [`us-wv`, 1], [`us-wi`, 2]]
                            }
                        ]
                    }
                },
                Education: {
                    chartOptions: {
                        main: 'Demographics',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`Did not graduate high school`, `High school or equivalent`, `Some college or university`, `College or university graduate`, `Some graduate school or continuing education`, `Completed graduate school or other continuing education`, `Trade school graduate`],
                        },
                        title: {
                            text: "Education"
                        },
                        series: [{
                                name: 'Count',
                                data: [4, 28, 80, 102, 24, 45, 6]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                Religion: {
                    chartOptions: {
                        main: 'Demographics',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'column'
                        },
                        xAxis: {
                            categories: [`Agnostic`, `Atheist`, `Atheist Jew`, `Buddhism`, `Christianity`, `Islam`, `Judaism`, `Neopaganism`, `None`, `Not sure/Undecided`, `Other`, `Satanist`, `Spiritual`, `Voudun`, `Wicca`],
                        },
                        title: {
                            text: "Religion"
                        },
                        series: [{
                                name: 'Count',
                                data: [68, 82, 4, 7, 55, 3, 2, 1, 34, 17, 3, 1, 10, 1, 1]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                In_the_last_year__how_many_times_have_you_been_arrested: {
                    chartOptions: {
                        main: 'Demographics',
                        size: '4',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`0`, `1`, `2`, `4`],
                        },
                        title: {
                            text: "In the last year, how many times have you been arrested?"
                        },
                        series: [{
                                name: 'Count',
                                data: [271, 14, 3, 1]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                Did_the_last_arrest_involve_alcohol: {
                    chartOptions: {
                        main: 'Demographics',
                        size: '4',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`No`, `No, but alcohol was involved`, `Yes`],
                        },
                        title: {
                            text: "Did the last arrest involve alcohol?"
                        },
                        series: [{
                                name: 'Count',
                                data: [3, 5, 10]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                In_the_last_year__how_many_times_have_you_been_to_jail: {
                    chartOptions: {
                        main: 'Demographics',
                        size: '4',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`0`, `1`, `2`, `3`, `4`],
                        },
                        title: {
                            text: "In the last year, how many times have you been to jail?"
                        },
                        series: [{
                                name: 'Count',
                                data: [275, 9, 3, 1, 1]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                Current_relationship_status: {
                    chartOptions: {
                        main: 'Demographics',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`Single`, `Committed Relationship`, `Engaged`, `Married`, `Separated`, `Divorced`, `Remarried`],
                        },
                        title: {
                            text: "Current relationship status"
                        },
                        series: [{
                                name: 'Count',
                                data: [128, 73, 14, 61, 1, 6, 6]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                If_you_re_currently_married_or_in_a_committed_relationship__is_your_partner_s_a_CA: {
                    chartOptions: {
                        main: 'Demographics',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'column'
                        },
                        xAxis: {
                            categories: [`They don't drink`, `They drink occasionally`, `They drink regularly`, `Alcoholic`, `CA`],
                        },
                        title: {
                            text: "If you're currently married or in a committed relationship, is your partner/s a CA?"
                        },
                        series: [{
                                name: 'Count',
                                data: [22, 88, 27, 13, 4]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                Your_upbringing_was_or_your_parents_were____: {
                    chartOptions: {
                        main: 'Demographics',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'column'
                        },
                        xAxis: {
                            categories: [`Adopted`, `Homeless`, `It's complicated`, `Married`, `Never Married`, `Raised by grandparents/other family`, `Raised by single father`, `Raised by single mother`, `Separated / divorced`],
                        },
                        title: {
                            text: "Your upbringing was or your parents were...."
                        },
                        series: [{
                                name: 'Count',
                                data: [2, 1, 10, 179, 12, 5, 1, 17, 62]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                In_the_last_year__have_you_been_affected_by_houselessness: {
                    chartOptions: {
                        main: 'Demographics',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'column'
                        },
                        xAxis: {
                            categories: [`No`, `Yes`],
                        },
                        title: {
                            text: "In the last year, have you been affected by houselessness?"
                        },
                        series: [{
                                name: 'Count',
                                data: [274, 14]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                How_many_children_do_you_have: {
                    chartOptions: {
                        main: 'Demographics',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`0`, `1`, `2`, `3`, `4`],
                        },
                        title: {
                            text: "How many children do you have?"
                        },
                        series: [{
                                name: 'Count',
                                data: [242, 18, 19, 7, 3]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                Are_you_currently_enrolled_as_a_student: {
                    chartOptions: {
                        main: 'Demographics',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`No`, `Yes`, `Yes, and I work`],
                        },
                        title: {
                            text: "Are you currently enrolled as a student?"
                        },
                        series: [{
                                name: 'Count',
                                data: [249, 20, 20]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                What_industry_do_you_currently_work_in: {
                    chartOptions: {
                        main: 'Demographics',
                        size: '12',
                        height: "auto",
                        chart: {
                            type: 'column',
                            marginLeft: 20,
                            scrollablePlotArea: {
                                minWidth: 2000,
                                scrollPositionX: 0
                            },
                        },
                        xAxis: {
                            categories: [`Accounting`, `Admin - clerical`, `Admin - legal`, `Animal industry`, `Animal industry `, `Art/creative`, `Automotive`, `Banking`, `Brewer`, `Construction`, `Distribution - shipping`, `Education`, `Engineering`, `Entertainment`, `Executive`, `Finance`, `General labor`, `Health Care`, `Hospitality`, `Human resources`, `Information technology`, `Installation/maintenance/repair`, `Legal`, `Maintenance`, `Manufacturing`, `Marketing`, `Media/journalism/newspaper`, `None / Unemployed`, `Nonprofit/social services`, `Other`, `Pharmaceutical`, `Publishing`, `Restaurant/food service`, `Retail`, `Retired`, `Sales`, `Science`, `Skilled labor/trades`, `Social Housing `],
                        },
                        title: {
                            text: "What industry do you currently work in?"
                        },
                        series: [{
                                name: 'Count',
                                data: [4, 2, 2, 1, 1, 3, 1, 3, 1, 4, 2, 13, 6, 4, 3, 5, 2, 16, 9, 1, 19, 1, 7, 1, 1, 4, 1, 35, 5, 1, 1, 1, 8, 7, 2, 9, 1, 6, 1]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                What_s_the_longest_you_ve_held_a_job: {
                    chartOptions: {
                        main: 'Demographics',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`N/A`, `Day/s`, `Month/s`, `1 Year`, `2 Years`, `3 Years`, `4 Years`, `5 Years`, `6 Years`, `7 Years`, `8 Years`, `9 Years`, `10 Years`, `11-15 Years`, `16-20 Years`, `21-25 Years`, `26-30 Years`, `30+ Years`],
                        },
                        title: {
                            text: "What's the longest you've held a job?"
                        },
                        series: [{
                                name: 'Count',
                                data: [9, 2, 18, 28, 23, 39, 18, 21, 19, 21, 14, 8, 14, 31, 10, 5, 2, 1]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                In_the_last_year__have_you_gained_or_lost_a_job: {
                    chartOptions: {
                        main: 'Demographics',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'column'
                        },
                        xAxis: {
                            categories: [`N/A`, `Gained a job`, `Lost a job`, `Both`, `Neither (stayed unemployed)`, `Neither (stayed employed)`],
                        },
                        title: {
                            text: "In the last year, have you gained or lost a job?"
                        },
                        series: [{
                                name: 'Count',
                                data: [10, 40, 14, 42, 39, 144]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                In_the_last_year__how_much_money_did_you_earn__in_USD_: {
                    chartOptions: {
                        main: 'Demographics',
                        size: '12',
                        height: "auto",
                        chart: {
                            type: 'column'
                        },
                        xAxis: {
                            categories: [`N/A`, `$0-$10,000`, `$10,001-$20,000`, `$20,001-$30,000`, `$30,001-$40,000`, `$40,001-$50,000`, `$50,001-$60,000`, `$60,001-$70,000`, `$70,001-$80,000`, `$80,001-$90,000`, `$90,001-$100,000`, `$100,000+`, `Decline to answer`],
                        },
                        title: {
                            text: "In the last year, how much money did you earn? (in USD)"
                        },
                        series: [{
                                name: 'Count',
                                data: [14, 44, 22, 16, 21, 16, 23, 20, 20, 7, 10, 54, 22]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                }

            }, //demographics
            fun: {

                Current_state_of_relationship_with_parents_or_caregiver_you_identified_most_strongly_with_while_growing_up: {
                    chartOptions: {
                        main: 'Fun',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`No Answer`, `Poor`, `Okay`, `Neutral`, `Fair`, `Good`],
                        },
                        title: {
                            text: "Current state of relationship with parents or caregiver you identified most strongly with while growing up"
                        },
                        series: [{
                                name: 'Count',
                                data: [9, 29, 55, 30, 26, 140]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                How_often_do_you_shower_bathe: {
                    chartOptions: {
                        main: 'Fun',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`Seldom`, `When there's a reason to/"as needed"`, `Only days I work`, `Once every few days`, `Every other day`, `Once a day`, `Multiple times a day`],
                        },
                        title: {
                            text: "How often do you shower/bathe?"
                        },
                        series: [{
                                name: 'Count',
                                data: [12, 30, 11, 51, 50, 96, 15]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                How_often_do_you_brush_your_teeth: {
                    chartOptions: {
                        main: 'Fun',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`None`, `Seldom`, `Almost every day`, `1 time per day`, `2 times per day`, `3 times per day`, `4 times per day`],
                        },
                        title: {
                            text: "How often do you brush your teeth?"
                        },
                        series: [{
                                name: 'Count',
                                data: [3, 37, 68, 76, 74, 6, 1]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                Do_you_have_any_pets_: {
                    chartOptions: {
                        main: 'Fun',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`Cat/s`, `None`, `Dog/s`, `Fish`, `Chicken/s`, `Reptile/s`, `Bird/s`, `Ducks`, `Gerbil/s`, `Hamster/s`, `Horse/s`, `Rabbit/s`, `Snake/s`, `Isopods`, `Gaboon viper`, `Cattle`, `Geese`],
                        },
                        title: {
                            text: "Do you have any pets? "
                        },
                        series: [{
                                name: 'Count',
                                data: [64, 68, 60, 7, 4, 3, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                Do_you_consider_yourself_a_violent_person: {
                    chartOptions: {
                        main: 'Fun',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'column'
                        },
                        xAxis: {
                            categories: [`No`, `Yes`],
                        },
                        title: {
                            text: "Do you consider yourself a violent person?"
                        },
                        series: [{
                                name: 'Count',
                                data: [243, 13]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                In_the_last_year__have_you_gotten_into_a_physical_fight_: {
                    chartOptions: {
                        main: 'Fun',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'column'
                        },
                        xAxis: {
                            categories: [`No`, `Yes`],
                        },
                        title: {
                            text: "In the last year, have you gotten into a physical fight? "
                        },
                        series: [{
                                name: 'Count',
                                data: [240, 21]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                Do_you_own_a_gun_multiple_guns: {
                    chartOptions: {
                        main: 'Fun',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`No`, `Yes`],
                        },
                        title: {
                            text: "Do you own a gun/multiple guns?"
                        },
                        series: [{
                                name: 'Count',
                                data: [210, 51]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                In_the_last_year__have_you_shot_it_them: {
                    chartOptions: {
                        main: 'Fun',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`No`, `Yes`],
                        },
                        title: {
                            text: "In the last year, have you shot it/them?"
                        },
                        series: [{
                                name: 'Count',
                                data: [24, 27]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                Here_we_are_again____poop__What_s_your_normal_consistency: {
                    chartOptions: {
                        main: 'Fun',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`Type 1`, `Type 2`, `Type 3`, `Type 4`, `Type 5`, `Type 6`, `Type 7`],
                        },
                        title: {
                            text: "Here we are again... poop. What's your normal consistency?"
                        },
                        series: [{
                                name: 'Count',
                                data: [2, 10, 29, 99, 43, 47, 21]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                What_hobbies_have_you_done_in_the_last_year: {
                    chartOptions: {
                        main: 'Fun',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'column',
                            marginRight: 20,
                            scrollablePlotArea: {
                                minWidth: 2000,
                                scrollPositionX: 0
                            },
                        },
                        xAxis: {
                            categories: [`Reading`, `Film/TV show watching`, `Videogames`, `Cooking/Baking`, `Hiking`, `Puzzle solving (crossword puzzles, jigsaw puzzles)`, `Gardening`, `Running/Jogging`, `Painting/Drawing`, `Traveling`, `Meditation`, `Writing`, `Playing a musical instrument`, `DIY Crafts`, `Cycling`, `Yoga`, `Collecting (e.g., stamps, coins, memorabilia)`, `Bird Watching`, `Playing sports (e.g., soccer, basketball, tennis)`, `Tabletop Gaming`, `Photography`, `Astronomy/Stargazing`, `Volunteering`, `Singing`, `Fishing`, `Dancing`, `Knitting/Crocheting`, `Skiing/Snowboarding`, `Model building (e.g., airplanes, cars)`, `Woodworking`, `Surfing`, `Brazilian Jiu Jitsu`, `Language Learning`, `AA meetings`, `Going to zoos`, `Thrifting`, `Working out`, `Swimming`, `Drugs? Is that a hobby?`, `Weight lifting`, `Deer hunting`, `Gym`, `Audiophile`, `Mechanical Keyboards`, `Programming`, `Weightlifting`, `Gaming`, `Exercise`, `Swimming`, `Golf`],
                            labels: {
                                rotation: 45
                            }

                        },
                        title: {
                            text: "What hobbies have you done in the last year?"
                        },
                        series: [{
                                name: 'Count',
                                data: [164, 150, 123, 115, 78, 74, 56, 56, 50, 50, 45, 42, 41, 40, 38, 35, 34, 30, 29, 29, 27, 23, 23, 20, 18, 16, 16, 12, 7, 5, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                How_many_sexual_partners_have_you_had_total: {
                    chartOptions: {
                        main: 'Fun',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'column'
                        },
                        xAxis: {
                            categories: [`0`, `1`, `2`, `3`, `4`, `5`, `6`, `7`, `8`, `9`, `10`, `11`, `12`, `13`, `14`, `15`, `16`, `17`, `18`, `20`, `21`, `23`, `25`, `30`, `35`, `40`, `45`, `48`, `50`, `57`, `60`, `65`, `75`, `80`, `100`, `101`, `110`, `140`, `142`, `153`, `170`, `180`, `200`, `300`, `350`],
                        },
                        title: {
                            text: "How many sexual partners have you had total?"
                        },
                        series: [{
                                name: 'Count',
                                data: [9, 27, 12, 9, 14, 13, 3, 8, 9, 9, 20, 1, 7, 4, 2, 9, 4, 3, 3, 12, 2, 1, 10, 19, 6, 3, 3, 1, 7, 2, 1, 1, 1, 1, 6, 1, 2, 1, 1, 1, 1, 1, 2, 2, 1]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                How_many_sexual_partners_have_you_had_this_year: {
                    chartOptions: {
                        main: 'Fun',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'column',
                        },
                        xAxis: {
                            categories: [`0`, `1`, `2`, `3`, `4`, `5`, `6`, `8`, `9`, `10`, `16`, `20`, `25`, `30`, `60`],
                        },
                        title: {
                            text: "How many sexual partners have you had this year?"
                        },
                        series: [{
                                name: 'Count',
                                data: [69, 128, 22, 10, 11, 4, 1, 1, 3, 1, 1, 1, 1, 1, 1]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                How_has_drinking_affected_your_libido: {
                    chartOptions: {
                        main: 'Fun',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'column'
                        },
                        xAxis: {
                            categories: [`Decreased`, `Increased`, `N/A`, `Neutral`, `Very Decreased`, `Very Increased`],
                        },
                        title: {
                            text: "How has drinking affected your libido?"
                        },
                        series: [{
                                name: 'Count',
                                data: [63, 51, 14, 88, 31, 11]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                }

            }, //fun
            drinking: {

                Do_you_consider_yourself_an_alcoholic: {
                    chartOptions: {
                        main: 'Drinking',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`No`, `Possibly`, `Yes, high functioning`, `Yes, between crippling and high functioning`, `Yes, crippling alcoholism`, `Yes, in recovery`],
                        },
                        title: {
                            text: "Do you consider yourself an alcoholic?"
                        },
                        series: [{
                                name: 'Count',
                                data: [7, 24, 69, 71, 27, 32]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                How_long_have_you_been_in_recovery_from_alcohol: {
                    chartOptions: {
                        main: 'Drinking',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'column'
                        },
                        xAxis: {
                            categories: [`1 month or less`, `3 months or less`, `6 months or less`, `1 year or less`, `2 years or less`, `3 years or less`, `4 years or less`, `5 years or less`, `6 years or less`, `7 years or less`, `8 years or less`, `9 years or less`, `10 or more years`],
                        },
                        title: {
                            text: "How long have you been in recovery from alcohol?"
                        },
                        series: [{
                                name: 'Count',
                                data: [4, 7, 2, 5, 2, 3, 2, 0, 1, 1, 1, 0, 1]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                On_average__how_many_days_per_week_do_you_drink: {
                    chartOptions: {
                        main: 'Drinking',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`0`, `1`, `2`, `3`, `4`, `5`, `6`, `7`],
                        },
                        title: {
                            text: "On average, how many days per week do you drink?"
                        },
                        series: [{
                                name: 'Count',
                                data: [28, 5, 12, 20, 18, 16, 27, 101]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                At_what_age_did_you_have_your_first_drink: {
                    chartOptions: {
                        main: 'Drinking',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'column'
                        },
                        xAxis: {
                            categories: [`1`, `3`, `4`, `5`, `6`, `8`, `9`, `10`, `11`, `12`, `13`, `14`, `15`, `16`, `17`, `18`, `19`, `20`, `21`, `22`, `24`],
                        },
                        title: {
                            text: "At what age did you have your first drink?"
                        },
                        series: [{
                                name: 'Count',
                                data: [1, 1, 2, 2, 1, 4, 2, 3, 10, 30, 26, 30, 34, 30, 19, 13, 10, 4, 4, 1, 1]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                At_what_age_did_you_start_drinking_reulgarly: {
                    chartOptions: {
                        main: 'Drinking',
                        size: '12',
                        height: "auto",
                        chart: {
                            type: 'column'
                        },
                        xAxis: {
                            categories: [`12`, `13`, `14`, `15`, `16`, `17`, `18`, `19`, `20`, `21`, `22`, `23`, `24`, `25`, `26`, `27`, `28`, `29`, `30`, `32`, `34`, `35`, `N/A`],
                        },
                        title: {
                            text: "At what age did you start drinking reulgarly?"
                        },
                        series: [{
                                name: 'Count',
                                data: [1, 6, 6, 18, 20, 18, 31, 19, 16, 30, 12, 14, 4, 10, 1, 5, 5, 2, 4, 1, 1, 2, 1]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                At_what_age_did_you_become_physically_dependent_on_alcohol: {
                    chartOptions: {
                        main: 'Drinking',
                        size: '12',
                        height: "auto",
                        chart: {
                            type: 'column'
                        },
                        xAxis: {
                            categories: [`13`, `14`, `17`, `18`, `19`, `20`, `21`, `22`, `23`, `24`, `25`, `26`, `27`, `28`, `29`, `30`, `31`, `32`, `33`, `34`, `35`, `36`, `37`, `38`, `39`, `40`, `42`, `43`, `45`, `50`, `100`, `N/A`],
                        },
                        title: {
                            text: "At what age did you become physically dependent on alcohol?"
                        },
                        series: [{
                                name: 'Count',
                                data: [1, 1, 3, 8, 6, 13, 13, 18, 6, 11, 11, 6, 9, 10, 5, 8, 5, 7, 5, 2, 7, 2, 3, 1, 1, 3, 1, 2, 2, 1, 1, 51]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                Does_someone_in_your_life_enable_your_alcoholism: {
                    chartOptions: {
                        main: 'Drinking',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`N/A`, `No`, `Yes`],
                        },
                        title: {
                            text: "Does someone in your life enable your alcoholism?"
                        },
                        series: [{
                                name: 'Count',
                                data: [40, 154, 95]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                Do_you_consider_yourself_a_binge_drinker_or_maintenance_drinker: {
                    chartOptions: {
                        main: 'Drinking',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'column'
                        },
                        xAxis: {
                            categories: [`Maintenance Drinker`, `Binge Drinker`, `Both`, `Neither`, `Other`],
                        },
                        title: {
                            text: "Do you consider yourself a binge drinker or maintenance drinker?"
                        },
                        series: [{
                                name: 'Count',
                                data: [27, 90, 92, 14, 1]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                When_maintaining__approximately_how_many_drinks_do_you_have_per_day: {
                    chartOptions: {
                        main: 'Drinking',
                        size: '12',
                        height: "auto",
                        chart: {
                            type: 'column'
                        },
                        xAxis: {
                            categories: [`0`, `1`, `2`, `3`, `4`, `5`, `6`, `7`, `8`, `9`, `10`, `11`, `12`, `14`, `15`, `16`, `17`, `18`, `20`, `23`, `24`, `25`, `30`, `40`, `60`, `65`],
                        },
                        title: {
                            text: "When maintaining, approximately how many drinks do you have per day?"
                        },
                        series: [{
                                name: 'Count',
                                data: [28, 1, 3, 13, 8, 13, 23, 14, 27, 6, 24, 2, 16, 4, 19, 1, 5, 2, 8, 1, 1, 1, 1, 1, 1, 1]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                When_binging__approximately_how_many_drinks_do_you_have_per_day: {
                    chartOptions: {
                        main: 'Drinking',
                        size: '12',
                        height: "auto",
                        chart: {
                            type: 'column'
                        },
                        xAxis: {
                            categories: [`0`, `3`, `5`, `6`, `7`, `8`, `9`, `10`, `11`, `12`, `13`, `14`, `15`, `16`, `17`, `18`, `20`, `21`, `22`, `23`, `24`, `25`, `28`, `30`, `35`, `40`, `44`, `50`, `80`, `100`],
                        },
                        title: {
                            text: `When binging, approximately how many drinks do you have per day?`
                        },
                        series: [{
                                name: 'Count',
                                data: [8, 1, 2, 4, 4, 9, 4, 26, 1, 20, 3, 12, 28, 8, 4, 9, 40, 2, 4, 2, 6, 4, 2, 9, 7, 4, 1, 1, 1, 1]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                How_much_money__in_USD__do_you_spend_on_alcohol_per_week: {
                    chartOptions: {
                        main: 'Drinking',
                        size: '4',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`0`, `10`, `13`, `14`, `15`, `18`, `20`, `21`, `25`, `28`, `30`, `35`, `38`, `40`, `42`, `45`, `50`, `55`, `60`, `65`, `70`, `75`, `80`, `85`, `88`, `90`, `95`, `100`, `105`, `110`, `120`, `130`, `140`, `150`, `166`, `175`, `180`, `200`, `250`, `300`, `400`, `500`],
                        },
                        title: {
                            text: "How much money (in USD) do you spend on alcohol per week?"
                        },
                        series: [{
                                name: 'Count',
                                data: [17, 5, 1, 1, 2, 1, 7, 1, 4, 1, 6, 1, 1, 11, 1, 1, 28, 1, 11, 1, 6, 6, 7, 3, 1, 2, 1, 35, 2, 1, 10, 1, 4, 14, 1, 2, 1, 8, 3, 3, 1, 3]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                Is_drinking_at_your_work_socially_acceptable: {
                    chartOptions: {
                        main: 'Drinking',
                        size: '4',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`N/A`, `No`, `Yes`],
                        },
                        title: {
                            text: "Is drinking at your work socially acceptable?"
                        },
                        series: [{
                                name: 'Count',
                                data: [36, 152, 36]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                How_often_do_you_drink_at_work: {
                    chartOptions: {
                        main: 'Drinking',
                        size: '4',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`A few days a year`, `A few days a month`, `A few days a week`, `Almost Every Day`, `Every Day`, `N/A`, `None`],
                        },
                        title: {
                            text: "How often do you drink at work?"
                        },
                        series: [{
                                name: 'Count',
                                data: [27, 15, 15, 12, 10, 10, 92]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                How_often_do_you_drink_before_work: {
                    chartOptions: {
                        main: 'Drinking',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'column'
                        },
                        xAxis: {
                            categories: [`A few days a year`, `A few days a month`, `A few days a week`, `Almost Every Day`, `Every Day`, `N/A`, `None`],
                        },
                        title: {
                            text: "How often do you drink before work?"
                        },
                        series: [{
                                name: 'Count',
                                data: [24, 20, 14, 11, 11, 7, 90]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                In_the_last_year__how_many_times_have_you_called_out_of_work_due_to_alcohol: {
                    chartOptions: {
                        main: 'Drinking',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'column'
                        },
                        xAxis: {
                            categories: [`0`, `1-3`, `4-6`, `7-10`, `11+`, `N/A`],
                        },
                        title: {
                            text: "In the last year, how many times have you called out of work due to alcohol?"
                        },
                        series: [{
                                name: 'Count',
                                data: [70, 48, 32, 21, 9, 13]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                In_the_last_year__how_many_times_have_you_been_dismissed_from_work_due_to_alcohol: {
                    chartOptions: {
                        main: 'Drinking',
                        size: '4',
                        height: "auto",
                        chart: {
                            type: 'column'
                        },
                        xAxis: {
                            categories: [`0`, `1`, `2`, `3`, `4`, `7`, `10+`, `N/A`],
                        },
                        title: {
                            text: "In the last year, how many times have you been dismissed from work due to alcohol?"
                        },
                        series: [{
                                name: 'Count',
                                data: [153, 8, 1, 2, 1, 1, 2, 24]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                How_often_do_you_blackout: {
                    chartOptions: {
                        main: 'Drinking',
                        size: '4',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`Never`, `Rarely`, `On occasion`, `Most times`, `Always`, `N/A`],
                        },
                        title: {
                            text: "How often do you blackout?"
                        },
                        series: [{
                                name: 'Count',
                                data: [26, 50, 68, 56, 18, 5]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                Do_you_have_a_drinking_buddy_that_can_keep_up_with_your_drinking: {
                    chartOptions: {
                        main: 'Drinking',
                        size: '4',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`N/A`, `No`, `Yes`],
                        },
                        title: {
                            text: "Do you have a drinking buddy that can keep up with your drinking?"
                        },
                        series: [{
                                name: 'Count',
                                data: [21, 129, 72]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                Do_your_friends_know_about_your_drinking_habits: {
                    chartOptions: {
                        main: 'Drinking',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`N/A`, `No`, `Yes`],
                        },
                        title: {
                            text: "Do your friends know about your drinking habits?"
                        },
                        series: [{
                                name: 'Count',
                                data: [13, 77, 135]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                Does_your_family_know_about_your_drinking_habits: {
                    chartOptions: {
                        main: 'Drinking',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'column'
                        },
                        xAxis: {
                            categories: [`N/A`, `No`, `Yes`],
                        },
                        title: {
                            text: "Does your family know about your drinking habits?"
                        },
                        series: [{
                                name: 'Count',
                                data: [4, 97, 119]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                In_the_last_year__have_you_tried_to_hide_your_drinking_from_friends_or_family: {
                    chartOptions: {
                        main: 'Drinking',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`Friends`, `Family`, `Both`, `Neither`, `N/A`],
                        },
                        title: {
                            text: "In the last year, have you tried to hide your drinking from friends or family?"
                        },
                        series: [{
                                name: 'Count',
                                data: [2, 53, 127, 32, 11]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                How_many_DUIs_have_you_had_total: {
                    chartOptions: {
                        main: 'Drinking',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`0`, `1`, `2`, `3`],
                        },
                        title: {
                            text: "How many DUIs have you had total?"
                        },
                        series: [{
                                name: 'Count',
                                data: [182, 31, 10, 4]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                Did_you_get_a_DUI_in_the_last_year: {
                    chartOptions: {
                        main: 'Drinking',
                        size: '12',
                        height: "auto",
                        chart: {
                            type: 'column'
                        },
                        xAxis: {
                            categories: [`N/A (Didn't drink, didn't drive, etc)`, `No`, `Yes`],
                        },
                        title: {
                            text: "Did you get a DUI in the last year?"
                        },
                        series: [{
                                name: 'Count',
                                data: [2, 37, 5]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                Alcohol_preference: {
                    chartOptions: {
                        main: 'Drinking',
                        size: '12',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`Beer`, `Bourbon`, `Brandy`, `Cider`, `Gin`, `Malt liquor`, `Rum`, `Tequila`, `Vodka`, `Whiskey`, `Wine`],
                        },
                        title: {
                            text: "Alcohol preference"
                        },
                        series: [{
                                name: 'Count',
                                data: [60, 8, 2, 2, 9, 6, 9, 4, 69, 22, 33]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                What_is_your_favorite_drink: {
                    chartOptions: {
                        main: 'Drinking',
                        size: '12',
                        height: "auto",
                        chart: {
                            type: 'column',
                            marginRight: 20,
                            scrollablePlotArea: {
                                minWidth: 2500,
                                scrollPositionX: 0
                            }
                        },
                        xAxis: {
                            categories: [`Vodka`, `Beer`, `Gin and Tonic`, `Gin and tonic`, `Whiskey`, `Red wine`, `Scotch`, `Red Wine`, `Old Fashioned`, `Old fashioned`, `White Wine`, `White Claw`, `IPA`, `Rum`, `Vodka Diet Soda`, `Vodka Lemonade`, `Vodka Soda`, `Rum and Coke`, `Jack and Coke`, `Sauvignon Blanc`, `Tequila`, `brandy`, `Vodka and Orange Juice`, `Martini`, `Boxed Wine`, `Vodka and Lemonade`, `Wine`, `Vodka and Coke`, `Brandy`, `Peach Bellinis`, `Desperados`, `Pinot Noir`, `Smirnoff`, `Whiskey Soda`, `Negroni`, `IPA Beer`, `Natural Ice`, `White Zinfandel`, `AAL`, `Alcohol`, `Rumplminze`, `White Claw Surge`, `White Claws`, `Piwko`, `Moscato`, `Rye Whiskey Neat`, `LIT`, `Mezcal`, `Beaupré Apple Cider`, `Rum Diet Coke`, `Vodka Water`, `Vodka Cranberry`, `Mojitos`, `Tea and also vodka`, `Tequila Club Soda`, `Jack Daniels`, `Tito’s`, `Rolling Rock`, `Vodka Selzter`, `Scotch and Soda`, `Macallan 12`, `Piss`, `Gin Tonic`, `Pineapple Mandarin Mikes Harders`, `Margarita`, `Burbon`, `Whiskey and Water`, `Tito's`, `Whiskey Neat`, `Vodka Shots and Beer`, `Warm Fireball`, `Captain Morgan Diet Coke`, `Irish Coffee`, `Hard Seltzers`, `Vodka Highball`, `Apple Taaka`, `Water`, `Chocolate Buzzballs`, `Gin and Soda`, `Liquor`, `Any sweet liquor`, `Imperial Cider`, `Pinot Grigio`, `Mike’s Harder Lemonade`, `Miller Lite`, `Vodka and Soda`, `Smirnoff Strawberry`, `Screwdriver`, `Glenlivit 12`, `Evan Williams`, `Corona and Lime`, `Whatevers cheapest`, `Any`, `Vodka Straight`, `Gin, Sprite, Grenadine`, `Iced Tea and Vodka`, `Vodka Sochu Soda`, `Smirnoff Vodka and Orange Juice`, `Strong`, `Sprite`, `Voodoo Ranger`, `Straight Vodka`, `Mojito`, `Whiskey Sour`, `Michelob Ultra`, `Long Island`, `Whiskey and Icehouse`, `Light Beer`, `Cheap Beer`, `Vodka and Diet Coke`, `White Rum`, `Vodka Lime`, `Summit Extra Pale Ale`, `Vodka and Flavored Seltzer`, `Hamms`, `Ballintines`, `Pisco`, `Steel Reserve`, `DIPA`, `Dark Beer`, `Buffalo Trace`, `99 shooters`, `Hazy IPA`, `Fireball`],
                            labels: {
                                rotation: 45
                            }
                        },
                        title: {
                            text: "What is your favorite drink?"
                        },
                        series: [{
                                name: 'Count',
                                data: [17, 14, 8, 8, 6, 4, 4, 4, 4, 4, 3, 3, 3, 3, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                In_the_last_year__did_you_use_an_atypical_source_of_alcohol_such_as_mouthwash__vanilla_extract__cooking_wine__etc__to_fight_off_withdrawals: {
                    chartOptions: {
                        main: 'Drinking',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'column'
                        },
                        xAxis: {
                            categories: [`N/A`, `No`, `Yes`],
                        },
                        title: {
                            text: "In the last year, did you use an atypical source of alcohol such as mouthwash, vanilla extract, cooking wine, etc. to fight off withdrawals?"
                        },
                        series: [{
                                name: 'Count',
                                data: [7, 190, 29]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                In_the_last_year__has_alcohol_been_your_first_choice_of_drug: {
                    chartOptions: {
                        main: 'Drinking',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'column'
                        },
                        xAxis: {
                            categories: [`N/A`, `No`, `Yes`],
                        },
                        title: {
                            text: "In the last year, has alcohol been your first choice of drug?"
                        },
                        series: [{
                                name: 'Count',
                                data: [8, 25, 191]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                }

            }, //drinking
            medical: {

                In_the_last_year__how_often_did_you_go_to_bars: {
                    chartOptions: {
                        main: 'Medical',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'column'
                        },
                        xAxis: {
                            categories: ['Hangover', 'Anxiety', 'Panic Attack', 'Sweating', 'Heart palpitations', 'Shakes', 'Insomnia', 'Seizure', 'DTs'],
                        },
                        title: {
                            text: "In the last year, how often did you go to bars?"
                        },
                        series: [{
                                name: 'Count',
                                data: [65, 80, 50, 28, 5]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                In_the_last_year__what_symptoms_have_you_experienced_as_a_result_of_alcohol: {
                    chartOptions: {
                        main: 'Medical',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`Auditory Hallucinations`, `cringe`, `Extreme horniness, hypocalcemia`, `Hallucinations`, `Hospitalization from throwing up for about 2 weeks straight.  I didn't seize, but I hallucinated and talked all kinds of nonsense. `, `Mental confusion, cotton mouth, brain fog, bile vomitting when going without, `, `Mild hallucinations, rage`, `Nausea`, `Nightmares`, `Possible mini seizures at night`, `Restless Legs`, `Shadow People. `, `Shortness of breath `, `Unexpected sensitivity/spontaneous ejaculation`],
                        },
                        title: {
                            text: "In the last year, what symptoms have you experienced as a result of alcohol?"
                        },
                        series: [{
                                name: 'Count',
                                data: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                In_the_last_year__how_often_have_you_puked_from__or_associated_with__drinking: {
                    chartOptions: {
                        main: 'Medical',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`Never`, `A few times a year`, `A few times a month`, `A few times a week`, `Every day`, `N/A`],
                        },
                        title: {
                            text: "In the last year, how often have you puked from (or associated with) drinking?"
                        },
                        series: [{
                                name: 'Count',
                                data: [51, 93, 44, 20, 8, 9]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                Do_you_have_current_ongoing_medical_issue_s_as_a_result_of_current_or_past_drinking: {
                    chartOptions: {
                        main: 'Medical',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`N/A`, `No`, `Yes`],
                        },
                        title: {
                            text: "Do you have current ongoing medical issue/s as a result of current or past drinking?"
                        },
                        series: [{
                                name: 'Count',
                                data: [89, 126, 74]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                In_the_last_year__have_you_taken_something_to_help_liver_function__Milk_thistle__B_vitamins__etc_: {
                    chartOptions: {
                        main: 'Medical',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`N/A`, `No`, `Yes`],
                        },
                        title: {
                            text: "In the last year, have you taken something to help liver function? (Milk thistle, B vitamins, etc)"
                        },
                        series: [{
                                name: 'Count',
                                data: [81, 84, 124]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                When_was_the_last_time_you_went_to_a_scheduled_medical_appointment__alcohol_related_or_otherwise_: {
                    chartOptions: {
                        main: 'Medical',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`A year or longer`, `Six months to a year`, `Three months to six months`, `A month to three months`, `Less than a month`],
                        },
                        title: {
                            text: "When was the last time you went to a scheduled medical appointment (alcohol related or otherwise)"
                        },
                        series: [{
                                name: 'Count',
                                data: [59, 38, 21, 31, 54]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                How_many_alcohol_related_hospitalizations_have_you_had_in_the_last_year: {
                    chartOptions: {
                        main: 'Medical',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`0`, `1`, `2`, `3`, `4`, `5`, `6`, `10+`],
                        },
                        title: {
                            text: "How many alcohol-related hospitalizations have you had in the last year?"
                        },
                        series: [{
                                name: 'Count',
                                data: [173, 21, 11, 1, 1, 1, 2, 2]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                Have_you_served_in_the_armed_forces_in_your_respective_country: {
                    chartOptions: {
                        main: 'Medical',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`N/A`, `No`, `Yes`],
                        },
                        title: {
                            text: "Have you served in the armed forces in your respective country?"
                        },
                        series: [{
                                name: 'Count',
                                data: [84, 195, 10]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                Have_you_had_an_adverse_childhood_experience: {
                    chartOptions: {
                        main: 'Medical',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`Maybe`, `No`, `Yes`],
                        },
                        title: {
                            text: "Have you had an adverse childhood experience?"
                        },
                        series: [{
                                name: 'Count',
                                data: [26, 70, 115]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                Do_you_believe_it_has_contributed_to_increased_alcohol_use: {
                    chartOptions: {
                        main: 'Medical',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`Maybe`, `No`, `Yes`],
                        },
                        title: {
                            text: "Do you believe it has contributed to increased alcohol use?"
                        },
                        series: [{
                                name: 'Count',
                                data: [41, 10, 86]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                How_much_has_depression_affected_you: {
                    chartOptions: {
                        main: 'Medical',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "How much has depression affected you?"
                        },
                        subtitle: {
                            text: '1 = No negative effects  2 = Slight negative effects  3 = Moderate negative effects  4 = Heavy negative effects  5 = Severe negative effects'
                        },
                        series: [{
                                name: 'Count',
                                data: [6, 28, 46, 51, 77]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                How_much_do_you_believe_drinking_has_affected_this_depression: {
                    chartOptions: {
                        main: 'Medical',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "How much do you believe drinking has affected this depression?"
                        },
                        subtitle: {
                            text: '1 = No negative effects  2 = Slight negative effects  3 = Moderate negative effects  4 = Heavy negative effects  5 = Severe negative effects'
                        },
                        series: [{
                                name: 'Count',
                                data: [15, 17, 44, 52, 72]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                How_much_has_general_anxiety_affected_you: {
                    chartOptions: {
                        main: 'Medical',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "How much has general anxiety affected you?"
                        },
                        subtitle: {
                            text: '1 = No negative effects  2 = Slight negative effects  3 = Moderate negative effects  4 = Heavy negative effects  5 = Severe negative effects'
                        },
                        series: [{
                                name: 'Count',
                                data: [5, 29, 48, 50, 77]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                How_much_do_you_believe_drinking_has_affected_this_general_anxiety: {
                    chartOptions: {
                        main: 'Medical',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "How much do you believe drinking has affected this general anxiety?"
                        },
                        subtitle: {
                            text: '1 = No negative effects  2 = Slight negative effects  3 = Moderate negative effects  4 = Heavy negative effects  5 = Severe negative effects'
                        },
                        series: [{
                                name: 'Count',
                                data: [17, 19, 36, 54, 78]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                How_much_has_social_anxiety_affected_you: {
                    chartOptions: {
                        main: 'Medical',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "How much has social anxiety affected you?"
                        },
                        subtitle: {
                            text: '1 = No negative effects  2 = Slight negative effects  3 = Moderate negative effects  4 = Heavy negative effects  5 = Severe negative effects'
                        },
                        series: [{
                                name: 'Count',
                                data: [25, 30, 47, 49, 57]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                How_much_do_you_believe_drinking_has_affected_this_social_anxiety: {
                    chartOptions: {
                        main: 'Medical',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "How much do you believe drinking has affected this social anxiety?"
                        },
                        subtitle: {
                            text: '1 = No negative effects  2 = Slight negative effects  3 = Moderate negative effects  4 = Heavy negative effects  5 = Severe negative effects'
                        },
                        series: [{
                                name: 'Count',
                                data: [58, 36, 30, 32, 47]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                How_has_alcohol_affected_your_personal_relationships: {
                    chartOptions: {
                        main: 'Medical',
                        size: '4',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "How has alcohol affected your personal relationships?"
                        },
                        subtitle: {
                            text: '1 = No negative effects  2 = Slight negative effects  3 = Moderate negative effects  4 = Heavy negative effects  5 = Severe negative effects'
                        },
                        series: [{
                                name: 'Count',
                                data: [29, 29, 51, 42, 54]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                How_has_alcohol_affected_your_romantic_relationships: {
                    chartOptions: {
                        main: 'Medical',
                        size: '4',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "How has alcohol affected your romantic relationships?"
                        },
                        subtitle: {
                            text: '1 = No negative effects  2 = Slight negative effects  3 = Moderate negative effects  4 = Heavy negative effects  5 = Severe negative effects'
                        },
                        series: [{
                                name: 'Count',
                                data: [27, 28, 41, 36, 64]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                How_has_alcohol_affected_your_social_life: {
                    chartOptions: {
                        main: 'Medical',
                        size: '4',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "How has alcohol affected your social life?"
                        },
                        subtitle: {
                            text: '1 = No negative effects  2 = Slight negative effects  3 = Moderate negative effects  4 = Heavy negative effects  5 = Severe negative effects'
                        },
                        series: [{
                                name: 'Count',
                                data: [31, 30, 47, 40, 55]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                What_medical_disorders_have_you_been_diagnosed_with_from_a_doctor: {
                    chartOptions: {
                        main: 'Medical',
                        size: '12',
                        height: "auto",
                        chart: {
                            type: 'column',
                            marginRight: 20,
                            scrollablePlotArea: {
                                minWidth: 2500,
                                scrollPositionX: 0
                            },
                        },
                        xAxis: {
                            categories: [`Acid Reflux`, `Acute Pancreatitis`, `Acute Withdraws`, `ADHD`, `Adjustment disorder`, `Afib`, `Agoraphobia`, `Alcohol Use Disorder`, `Alcoholic Hepatitis`, `Alcoholic hepatitis`, `Anemia`, `Anxiety`, `Asthma`, `Autism`, `Avascular necrosis`, `Benzodiazepine Use Disorder`, `Bipolar Disorder`, `Bipolar Disorder Type 1`, `Bipolar Disorder Type 2`, `Borderline Personality Disorder`, `Bulimia`, `Celiac Disease`, `Charcot-Marie-Tooth Disease`, `Chronic Pain`, `Chronic Pancreatitis`, `Chronic Shoulder Issues`, `Cirrhosis`, `Cocaine Use Disorder`, `Crohns disease`, `Depression`, `Diabetes`, `Dissociative Identity Disorder`, `Dysthymia`, `Elevated Liver Enzymes`, `Enlarged spleen /Splenomegaly`, `Eosinophilia`, `Epilepsy`, `Fatty Liver`, `Gastritis`, `Generalized anxiety disorder`, `Generallized Anxiety Disorder`, `GERD`, `Glaucoma`, `Gout`, `Hallucinogen Persisting Perception Disorder`, `Hearing Loss`, `Heart Arrhythmia`, `Hernia`, `Hidradenitis Suppurativa`, `High Blood Pressure`, `High Cholesterol`, `High Liver Enzymes`, `Hypertension`, `hypertension`, `Hyperthyroidism`, `Hypocalcemia`, `Hypothyroidism`, `Insomnia`, `Irritable Bowel Syndrome`, `Kidney disease`, `Kidney problems`, `Liver damage`, `Low-Testosterone`, `Major Depressive Disorder`, `Manic Depression`, `Methamphetamine Use Disorder`, `Migraines`, `Multiple Sclerosis`, `Neuropathy`, `Non-verbal Learning Disability`, `Obesity`, `Obsessive Compulsive Disorder`, `Opioid Use Disorder`, `Pancreatitis`, `Panic Disorder`, `PCOS`, `Peptic Ulcer`, `Post Partum Depression`, `Postural Orthostatic Tachycardia Syndrome`, `Pre-Diabetic`, `Premenstrual Dysphoric Disorder`, `Psoriasis`, `PTSD`, `PTSD, Complex`, `Raynaud's Syndrome`, `Repeated liver tests`, `Schizoaffective Disorder`, `Schizophrenia`, `Sciatica`, `Seizure Disorder`, `Short breath`, `Social Anxiety`, `Substance Use DIsorder`, `Thrombocytopenia`, `TMJ`, `Tobacco use disorder`, `Treatment Resistant Major Depressive Disorder`, `Type 2 Diabetes`, `Ulcerative Colitis`, `Vitamin Deficiency`],
                            labels: {
                                rotation: 45
                            }

                        },
                        title: {
                            text: "What medical disorders have you been diagnosed with from a doctor?"
                        },
                        series: [{
                                name: 'Count',
                                data: [1, 1, 1, 10, 1, 1, 1, 18, 2, 2, 2, 12, 5, 5, 1, 1, 9, 1, 4, 3, 3, 1, 1, 1, 1, 1, 3, 1, 1, 12, 2, 1, 2, 2, 1, 1, 2, 6, 1, 3, 14, 4, 1, 2, 1, 1, 2, 1, 1, 5, 1, 1, 6, 6, 1, 1, 2, 3, 2, 1, 1, 1, 1, 16, 2, 1, 2, 1, 4, 1, 3, 3, 3, 3, 5, 1, 1, 1, 1, 3, 1, 1, 7, 2, 1, 1, 3, 2, 1, 4, 1, 7, 1, 1, 1, 1, 1, 1, 1, 1]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                Do_you_receive_medication_for_any_disorders_listed_above: {
                    chartOptions: {
                        main: 'Medical',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`N/A`, `No`, `Yes`],
                        },
                        title: {
                            text: "Do you receive medication for any disorders listed above?"
                        },
                        series: [{
                                name: 'Count',
                                data: [178, 32, 79]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                Has_drinking_worsened_the_symptoms_of_any_of_the_disorders_above: {
                    chartOptions: {
                        main: 'Medical',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`No`, `Not sure`, `Yes`],
                        },
                        title: {
                            text: "Has drinking worsened the symptoms of any of the disorders above?"
                        },
                        series: [{
                                name: 'Count',
                                data: [10, 21, 84]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                In_your_lifetime__have_you_felt_gender_dysphoria: {
                    chartOptions: {
                        main: 'Medical',
                        size: '4',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`N/A`, `No`, `Yes`],
                        },
                        title: {
                            text: "In your lifetime, have you felt gender dysphoria?"
                        },
                        series: [{
                                name: 'Count',
                                data: [83, 178, 28]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                Do_you_believe_these_feelings_have_contributed_to_increased_alcohol_use: {
                    chartOptions: {
                        main: 'Medical',
                        size: '4',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`N/A`, `No`, `Yes`],
                        },
                        title: {
                            text: "Do you believe these feelings have contributed to increased alcohol use?"
                        },
                        series: [{
                                name: 'Count',
                                data: [261, 13, 15]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                Have_you_ever_self_harmed__besides_drugs_alcohol_: {
                    chartOptions: {
                        main: 'Medical',
                        size: '4',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`N/A`, `No`, `Yes`],
                        },
                        title: {
                            text: "Have you ever self harmed (besides drugs/alcohol)?"
                        },
                        series: [{
                                name: 'Count',
                                data: [81, 109, 99]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                In_the_last_year: {
                    chartOptions: {
                        main: 'Medical',
                        size: '4',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`N/A`, `No`, `Yes`],
                        },
                        title: {
                            text: "In the last year?"
                        },
                        series: [{
                                name: 'Count',
                                data: [190, 61, 38]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                Do_you_have_a_therapist_or_otherwise_receive_regular_psychiatric_care_: {
                    chartOptions: {
                        main: 'Medical',
                        size: '4',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`N/A`, `No`, `Yes`],
                        },
                        title: {
                            text: "Do you have a therapist or otherwise receive regular psychiatric care? "
                        },
                        series: [{
                                name: 'Count',
                                data: [81, 137, 71]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                Do_you_consider_it_helpful: {
                    chartOptions: {
                        main: 'Medical',
                        size: '4',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`No`, `Sometimes`, `Yes`],
                        },
                        title: {
                            text: "Do you consider it helpful?"
                        },
                        series: [{
                                name: 'Count',
                                data: [8, 34, 28]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                Does_your_family_have_a_history_of_alcoholism: {
                    chartOptions: {
                        main: 'Medical',
                        size: '4',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`N/A`, `No`, `Yes`],
                        },
                        title: {
                            text: "Does your family have a history of alcoholism?"
                        },
                        series: [{
                                name: 'Count',
                                data: [87, 48, 154]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                How_many_hours_of_sleep_do_you_usually_get_on_average: {
                    chartOptions: {
                        main: 'Medical',
                        size: '4',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`3`, `4`, `5`, `6`, `7`, `8`, `9`, `10`, `12`, `16`],
                        },
                        title: {
                            text: "How many hours of sleep do you usually get on average?"
                        },
                        series: [{
                                name: 'Count',
                                data: [2, 18, 32, 70, 35, 27, 12, 9, 1, 2]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                In_the_last_year__have_you_had_a_night_terror_: {
                    chartOptions: {
                        main: 'Medical',
                        size: '4',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`N/A`, `No`, `Yes`],
                        },
                        title: {
                            text: "In the last year, have you had a night terror? "
                        },
                        series: [{
                                name: 'Count',
                                data: [87, 109, 93]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                Do_you_regularly_piss_the_bed_from_drinking: {
                    chartOptions: {
                        main: 'Medical',
                        size: '4',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`No`, `No, irregularly`, `Yes`],
                        },
                        title: {
                            text: "Do you regularly piss the bed from drinking?"
                        },
                        series: [{
                                name: 'Count',
                                data: [166, 36, 5]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                Have_your_family_friends_staged_an_intervention_for_you_in_the_last_year: {
                    chartOptions: {
                        main: 'Medical',
                        size: '4',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`N/A`, `No`, `Yes`],
                        },
                        title: {
                            text: "Have your family/friends staged an intervention for you in the last year?"
                        },
                        series: [{
                                name: 'Count',
                                data: [85, 183, 21]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                In_the_last_year__have_you_tried_to_stop_drinking_: {
                    chartOptions: {
                        main: 'Medical',
                        size: '4',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`N/A`, `No`, `Yes`, `Yes, it was a forced decision (family, court, etc)`],
                        },
                        title: {
                            text: "In the last year, have you tried to stop drinking? "
                        },
                        series: [{
                                name: 'Count',
                                data: [10, 58, 123, 16]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                How_often_do_you_think_about_quitting_alcohol: {
                    chartOptions: {
                        main: 'Medical',
                        size: '4',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`N/A`, `Never`, `Rarely`, `Occasionally`, `Sometimes`, `Frequently`, `Always`],
                        },
                        title: {
                            text: "How often do you think about quitting alcohol?"
                        },
                        series: [{
                                name: 'Count',
                                data: [11, 2, 17, 38, 29, 67, 46]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                How_many_times: {
                    chartOptions: {
                        main: 'Medical',
                        size: '4',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`0`, `1`, `2`, `3`, `4`, `5`, `6`, `7`, `8`, `10+`],
                        },
                        title: {
                            text: "How many times?"
                        },
                        series: [{
                                name: 'Count',
                                data: [2, 4, 13, 15, 3, 11, 10, 2, 3, 70]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                What_was_the_longest_period_of_abstinance: {
                    chartOptions: {
                        main: 'Medical',
                        size: '4',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`N/A`, `Up to a day`, `A day to a week`, `A week to a month`, `A month to 3 months`, `3 months to 6 months`, `6 months to a year`],
                        },
                        title: {
                            text: "What was the longest period of abstinance?"
                        },
                        series: [{
                                name: 'Count',
                                data: [1, 3, 28, 33, 26, 19, 28]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                In_your_experience__which_medications_have_helped_the_most_when_detoxing: {
                    chartOptions: {
                        main: 'Medical',
                        size: '12',
                        height: "auto",
                        chart: {
                            type: 'column',
                            marginRight: 20,
                            scrollablePlotArea: {
                                minWidth: 2000,
                                scrollPositionX: 0
                            },
                        },
                        xAxis: {
                            categories: [`Benzodiazepine`, `N/A`, `Librium`, `None`, `Ativan`, `Gabapentin`, `Naltrexone`, `Valium`, `Xanax`, `Alcohol`, `Antabuse`, `Diazepam`, `Vitamins`, `Baclofen`, `Benadryl`, `Cannabis`, `Clonidine`, `Klonopin`, `Kratom`, `L-theanine`, `Magnesium`, `Marijuana`, `Melatonin`, `Phenobarbital`, `Vitamin B`, `Adavan`, `Advil`, `Agmatine`, `Antihistamine`, `Ashwaghanda`, `Bacopa Monieri`, `Baikal Skullcap`, `Benzonatate`, `Buspar`, `Citalopram`, `Clonazepam`, `Decongestant`, `Diphenhydramine`, `Doxepin`, `Ephedrine`, `Gotu Kola`, `Ketamine`, `Lorazepam`, `Mecklizine`, `Modafinil`, `Muscle Relaxers`, `Na`, `Narcotics`, `Neurontin`, `Oxycodone`, `Quetapine`, `Seresta`, `Shrooms`, `Sleeping Medications`, `Taurine`, `Trazadone`, `Valerian`, `Vitaman B`, `Vivitrol`, `Weed`, `Xanex`, `Zofran`],
                            labels: {
                                rotation: 45
                            }
                        },
                        title: {
                            text: "In your experience, which medications have helped the most when detoxing?"
                        },
                        series: [{
                                name: 'Count',
                                data: [18, 11, 9, 9, 8, 6, 6, 6, 5, 3, 3, 3, 3, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                How_many_times_have_you_been_to_a_facility_to_detox_from_alcohol_in_the_last_year: {
                    chartOptions: {
                        main: 'Medical',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`0`, `1`, `2`, `4`, `5`, `8`, `9`],
                        },
                        title: {
                            text: "How many times have you been to a facility to detox from alcohol in the last year?"
                        },
                        series: [{
                                name: 'Count',
                                data: [39, 19, 2, 1, 1, 1, 1]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },

                How_many_times_have_you_been_to_a_facility_to_detox_from_alcohol_over_the_course_of_your_life: {
                    chartOptions: {
                        main: 'Medical',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`0`, `1`, `2`, `3`, `4`, `5`, `6`, `10`, `11`, `15`, `17`, `20`, `22`, `80`],
                        },
                        title: {
                            text: "How many times have you been to a facility to detox from alcohol over the course of your life?"
                        },
                        series: [{
                                name: 'Count',
                                data: [146, 30, 11, 7, 3, 3, 2, 1, 1, 1, 1, 1, 1, 1]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                How_many_times_have_you_been_to_inpatient_treatment_for_alcohol_use_over_the_course_of_your_life: {
                    chartOptions: {
                        main: 'Medical',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`, `8`, `10+`],
                        },
                        title: {
                            text: "How many times have you been to inpatient treatment for alcohol use over the course of your life?"
                        },
                        series: [{
                                name: 'Count',
                                data: [11, 3, 1, 4, 1, 1, 1]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                Have_you_ever_started_inpatient_treatment_for_alcohol_use: {
                    chartOptions: {
                        main: 'Medical',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`N/A`, `No`, `Yes`],
                        },
                        title: {
                            text: "Have you ever started inpatient treatment for alcohol use?"
                        },
                        series: [{
                                name: 'Count',
                                data: [82, 166, 41]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                How_many_times_have_you_started_inpatient_treatment_for_alcohol_use_in_the_last_year: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`0`, `1`, `2`, `3`, `8`],
                        },
                        title: {
                            text: "How many times have you started inpatient treatment for alcohol use in the last year?"
                        },
                        series: [{
                                name: 'Count',
                                data: [24, 10, 1, 4, 1]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                How_many_times_have_you_completed_inpatient_treatment_for_alcohol_use_in_the_last_year: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`0`, `1`, `3`],
                        },
                        title: {
                            text: "How many times have you completed inpatient treatment for alcohol use in the last year?"
                        },
                        series: [{
                                name: 'Count',
                                data: [26, 10, 3]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
Current_Weight: {
    chartOptions: {
        main: 'Drug_Use',
        size: '12',
        height: "auto",
        chart: {
			type: 'column',
			marginRight: 20,
			scrollablePlotArea: {
				minWidth: 2000,
				scrollPositionX: 0
			},
		},
        xAxis: {
          categories: [`90 (41 Kg)`,`91 (41 Kg)`,`92 (42 Kg)`,`93 (42 Kg)`,`94 (43 Kg)`,`95 (43 Kg)`,`96 (44 Kg)`,`97 (44 Kg)`,`98 (44 Kg)`,`99 (45 Kg)`,`100 (45 Kg)`,`101 (46 Kg)`,`102 (46 Kg)`,`103 (47 Kg)`,`104 (47 Kg)`,`105 (48 Kg)`,`106 (48 Kg)`,`107 (49 Kg)`,`108 (49 Kg)`,`109 (49 Kg)`,`110 (50 Kg)`,`111 (50 Kg)`,`112 (51 Kg)`,`113 (51 Kg)`,`114 (52 Kg)`,`115 (52 Kg)`,`116 (53 Kg)`,`117 (53 Kg)`,`118 (54 Kg)`,`119 (54 Kg)`,`120 (54 Kg)`,`121 (55 Kg)`,`122 (55 Kg)`,`123 (56 Kg)`,`124 (56 Kg)`,`125 (57 Kg)`,`126 (57 Kg)`,`127 (58 Kg)`,`128 (58 Kg)`,`129 (59 Kg)`,`130 (59 Kg)`,`131 (59 Kg)`,`132 (60 Kg)`,`133 (60 Kg)`,`134 (61 Kg)`,`135 (61 Kg)`,`136 (62 Kg)`,`137 (62 Kg)`,`138 (63 Kg)`,`139 (63 Kg)`,`140 (64 Kg)`,`141 (64 Kg)`,`142 (64 Kg)`,`143 (65 Kg)`,`144 (65 Kg)`,`145 (66 Kg)`,`146 (66 Kg)`,`147 (67 Kg)`,`148 (67 Kg)`,`149 (68 Kg)`,`150 (68 Kg)`,`151 (68 Kg)`,`152 (69 Kg)`,`153 (69 Kg)`,`154 (70 Kg)`,`155 (70 Kg)`,`156 (71 Kg)`,`157 (71 Kg)`,`158 (72 Kg)`,`159 (72 Kg)`,`160 (73 Kg)`,`161 (73 Kg)`,`162 (73 Kg)`,`163 (74 Kg)`,`164 (74 Kg)`,`165 (75 Kg)`,`166 (75 Kg)`,`167 (76 Kg)`,`168 (76 Kg)`,`169 (77 Kg)`,`170 (77 Kg)`,`171 (78 Kg)`,`172 (78 Kg)`,`173 (78 Kg)`,`174 (79 Kg)`,`175 (79 Kg)`,`176 (80 Kg)`,`177 (80 Kg)`,`178 (81 Kg)`,`179 (81 Kg)`,`180 (82 Kg)`,`181 (82 Kg)`,`182 (83 Kg)`,`183 (83 Kg)`,`184 (83 Kg)`,`185 (84 Kg)`,`186 (84 Kg)`,`187 (85 Kg)`,`188 (85 Kg)`,`189 (86 Kg)`,`190 (86 Kg)`,`191 (87 Kg)`,`192 (87 Kg)`,`193 (88 Kg)`,`194 (88 Kg)`,`195 (88 Kg)`,`196 (89 Kg)`,`197 (89 Kg)`,`198 (90 Kg)`,`199 (90 Kg)`,`200 (91 Kg)`,`201 (91 Kg)`,`202 (92 Kg)`,`203 (92 Kg)`,`204 (93 Kg)`,`205 (93 Kg)`,`206 (93 Kg)`,`207 (94 Kg)`,`208 (94 Kg)`,`209 (95 Kg)`,`210 (95 Kg)`,`211 (96 Kg)`,`212 (96 Kg)`,`213 (97 Kg)`,`214 (97 Kg)`,`215 (98 Kg)`,`216 (98 Kg)`,`217 (98 Kg)`,`218 (99 Kg)`,`219 (99 Kg)`,`220 (100 Kg)`,`221 (100 Kg)`,`222 (101 Kg)`,`223 (101 Kg)`,`224 (102 Kg)`,`225 (102 Kg)`,`226 (103 Kg)`,`227 (103 Kg)`,`228 (103 Kg)`,`229 (104 Kg)`,`230 (104 Kg)`,`231 (105 Kg)`,`232 (105 Kg)`,`233 (106 Kg)`,`234 (106 Kg)`,`235 (107 Kg)`,`236 (107 Kg)`,`237 (108 Kg)`,`238 (108 Kg)`,`239 (108 Kg)`,`240 (109 Kg)`,`241 (109 Kg)`,`242 (110 Kg)`,`243 (110 Kg)`,`244 (111 Kg)`,`245 (111 Kg)`,`246 (112 Kg)`,`247 (112 Kg)`,`248 (112 Kg)`,`249 (113 Kg)`,`250 (113 Kg)`,`251 (114 Kg)`,`252 (114 Kg)`,`253 (115 Kg)`,`254 (115 Kg)`,`255 (116 Kg)`,`256 (116 Kg)`,`257 (117 Kg)`,`258 (117 Kg)`,`259 (117 Kg)`,`260 (118 Kg)`,`261 (118 Kg)`,`262 (119 Kg)`,`263 (119 Kg)`,`264 (120 Kg)`,`265 (120 Kg)`,`266 (121 Kg)`,`267 (121 Kg)`,`268 (122 Kg)`,`269 (122 Kg)`,`270 (122 Kg)`,`271 (123 Kg)`,`272 (123 Kg)`,`273 (124 Kg)`,`274 (124 Kg)`,`275 (125 Kg)`,`276 (125 Kg)`,`277 (126 Kg)`,`278 (126 Kg)`,`279 (127 Kg)`,`280 (127 Kg)`,`281 (127 Kg)`,`282 (128 Kg)`,`283 (128 Kg)`,`284 (129 Kg)`,`285 (129 Kg)`,`286 (130 Kg)`,`287 (130 Kg)`,`288 (131 Kg)`,`289 (131 Kg)`,`290 (132 Kg)`,`291 (132 Kg)`,`292 (132 Kg)`,`293 (133 Kg)`,`294 (133 Kg)`,`295 (134 Kg)`,`296 (134 Kg)`,`297 (135 Kg)`,`298 (135 Kg)`,`299 (136 Kg)`,`300 (136 Kg)`,`301 (137 Kg)`,`302 (137 Kg)`,`303 (137 Kg)`,`304 (138 Kg)`,`305 (138 Kg)`,`306 (139 Kg)`,`307 (139 Kg)`,`308 (140 Kg)`,`309 (140 Kg)`,`310 (141 Kg)`,`311 (141 Kg)`,`312 (142 Kg)`,`313 (142 Kg)`,`314 (142 Kg)`,`315 (143 Kg)`,`316 (143 Kg)`,`317 (144 Kg)`,`318 (144 Kg)`,`319 (145 Kg)`,`320 (145 Kg)`,`321 (146 Kg)`,`322 (146 Kg)`,`323 (147 Kg)`,`324 (147 Kg)`,`325 (147 Kg)`,`326 (148 Kg)`,`327 (148 Kg)`,`328 (149 Kg)`,`329 (149 Kg)`,`330 (150 Kg)`,`331 (150 Kg)`,`332 (151 Kg)`,`333 (151 Kg)`,`334 (151 Kg)`,`335 (152 Kg)`,`336 (152 Kg)`,`337 (153 Kg)`,`338 (153 Kg)`,`339 (154 Kg)`,`340 (154 Kg)`,`341 (155 Kg)`,`342 (155 Kg)`,`343 (156 Kg)`,`344 (156 Kg)`,`345 (156 Kg)`,`346 (157 Kg)`,`347 (157 Kg)`,`348 (158 Kg)`,`349 (158 Kg)`,`350 (159 Kg)`,`351 (159 Kg)`,`352 (160 Kg)`,`353 (160 Kg)`,`354 (161 Kg)`,`355 (161 Kg)`,`356 (161 Kg)`,`357 (162 Kg)`,`358 (162 Kg)`,`359 (163 Kg)`,`360 (163 Kg)`,`361 (164 Kg)`,`362 (164 Kg)`,`363 (165 Kg)`,`364 (165 Kg)`,`365 (166 Kg)`,`366 (166 Kg)`,`367 (166 Kg)`,`368 (167 Kg)`,`369 (167 Kg)`,`370 (168 Kg)`,`371 (168 Kg)`,`372 (169 Kg)`,`373 (169 Kg)`,`374 (170 Kg)`,`375 (170 Kg)`,`376 (171 Kg)`,`377 (171 Kg)`,`378 (171 Kg)`,`379 (172 Kg)`,`380 (172 Kg)`,`381 (173 Kg)`,`382 (173 Kg)`,`383 (174 Kg)`,`384 (174 Kg)`,`385 (175 Kg)`,`386 (175 Kg)`,`387 (176 Kg)`,`388 (176 Kg)`,`389 (176 Kg)`,`390 (177 Kg)`,`391 (177 Kg)`,`392 (178 Kg)`,`393 (178 Kg)`,`394 (179 Kg)`,`395 (179 Kg)`,`396 (180 Kg)`,`397 (180 Kg)`,`398 (181 Kg)`,`399 (181 Kg)`,`400 (181 Kg)`,`401 (182 Kg)`,`402 (182 Kg)`,`403 (183 Kg)`,`404 (183 Kg)`,`405 (184 Kg)`,`406 (184 Kg)`,`407 (185 Kg)`,`408 (185 Kg)`,`409 (186 Kg)`,`410 (186 Kg)`],
		  labels: {
			rotation: 45
			}
        },
        title: {
          text: "Current Weight"
        },
        series: [
          {
            name: 'Count',
            data: [1, null, 0, null, 0, null, 0, null, 1, null, 0, null, 0, null, 0, null, 0, null, 0, null, 0, null, 0, null, 1, 1, null, 0, null, 0, null, 3, 2, 1, null, 2, 1, null, 1, null, 2, null, 1, null, 0, 4, null, 2, 1, 2, 6, 2, null, 1, null, 6, 1, null, 3, null, 10, null, 1, 1, 2, 3, null, 1, null, 1, 7, null, 0, null, 0, 7, 2, null, 2, null, 10, null, 0, null, 1, 6, 3, null, 1, 1, 9, 1, null, 1, 1, 5, null, 2, 1, 1, 4, null, 1, 1, null, 3, 1, 2, 4, null, 9, null, 0, 1, null, 5, null, 0, null, 3, 1, null, 0, null, 1, 4, 1, null, 0, null, 5, null, 0, null, 0, 4, null, 0, 1, null, 2, null, 0, null, 0, 1, null, 0, null, 0, 2, null, 0, 3, null, 1, null, 0, null, 1, 2, null, 0, null, 0, null, 0, null, 0, null, 0, null, 0, null, 0, 2, null, 0, null, 0, null, 0, null, 0, null, 4, null, 0, null, 0, 2, null, 0, null, 0, 1, null, 0, null, 0, 1, null, 0, null, 0, null, 0, null, 0, null, 0, null, 0, null, 0, null, 0, null, 0, null, 0, null, 0, null, 0, null, 0, null, 0, null, 0, null, 0, null, 0, null, 0, null, 0, null, 2, null, 0, null, 0, null, 0, null, 0, null, 2, null, 0, null, 0, null, 0, null, 0, null, 1, null, 0, null, 0, null, 0, null, 0, null, 0, null, 0, null, 0, null, 0, null, 0, null, 0, null, 0, null, 0, null, 0, null, 0, null, 0, null, 0, null, 0, null, 0, null, 0, null, 0, null, 0, null, 0, 1, null, 0, null, 0, null, 0, null, 0, null, 0, null, 0, null, 0, 1]
          }
        ],
        legend: {
          enabled: false
        }
      }
}
            }, //medical
            drug_Use: {
                CURRENT_DRUG_USE__Tobacco: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "CURRENT DRUG USE  Tobacco"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [88, 31, 14, 21, 39]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                CURRENT_DRUG_USE__Nicotine_Vaping: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "CURRENT DRUG USE  Nicotine Vaping"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [114, 14, 10, 10, 49]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                CURRENT_DRUG_USE__Marijuana: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "CURRENT DRUG USE  Marijuana"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [73, 49, 25, 32, 17]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                CURRENT_DRUG_USE__Hash_or_other_marijuana_concentrates: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "CURRENT DRUG USE  Hash or other marijuana concentrates"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [139, 21, 11, 14, 3]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                CURRENT_DRUG_USE__Cocaine: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "CURRENT DRUG USE  Cocaine"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [156, 27, 8, 1, 1]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                CURRENT_DRUG_USE__Crack: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "CURRENT DRUG USE  Crack"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [184, 4, 0, 0, 0]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                CURRENT_DRUG_USE__Light_sleeping_medication__antihistamines_diphenhydramine__etc__Melatonin__Valarian_root__etc_: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "CURRENT DRUG USE  Light sleeping medication (antihistamines diphenhydramine, etc, Melatonin, Valarian root, etc)"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [79, 48, 29, 26, 13]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                CURRENT_DRUG_USE__Other_sleep_medications__Hypnotic_benzos__temazepan__nitrazepan__etc___Z_drugs__Lunesta__ambien__etc___etc_: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "CURRENT DRUG USE  Other sleep medications: Hypnotic benzos (temazepan, nitrazepan, etc), Z-drugs (Lunesta, ambien, etc), etc."
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [153, 19, 6, 8, 5]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                CURRENT_DRUG_USE__Prescription_amphetamines: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "CURRENT DRUG USE  Prescription amphetamines"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [153, 9, 7, 18, 4]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                CURRENT_DRUG_USE__Methamphetamine: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "CURRENT DRUG USE  Methamphetamine"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [176, 7, 3, 2, 1]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                CURRENT_DRUG_USE__MDMA_estacy: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "CURRENT DRUG USE  MDMA/estacy"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [172, 14, 5, 0, 0]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                CURRENT_DRUG_USE__Mushrooms: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "CURRENT DRUG USE  Mushrooms"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [145, 38, 5, 2, 0]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                CURRENT_DRUG_USE__LSD: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "CURRENT DRUG USE  LSD"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [166, 20, 2, 1, 0]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                CURRENT_DRUG_USE__Heroin_Opium: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "CURRENT DRUG USE  Heroin/Opium"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [182, 3, 0, 1, 2]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                CURRENT_DRUG_USE__Kratom: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "CURRENT DRUG USE  Kratom"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [166, 12, 4, 5, 4]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                CURRENT_DRUG_USE__Kava: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "CURRENT DRUG USE  Kava"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [178, 6, 2, 1, 0]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                CURRENT_DRUG_USE__Gabanergics__Kratom__Phenibut__etc_: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "CURRENT DRUG USE  Gabanergics (Kratom, Phenibut, etc)"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [170, 12, 2, 3, 1]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                CURRENT_DRUG_USE__Prescription_opiates: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "CURRENT DRUG USE  Prescription opiates"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [170, 11, 5, 0, 1]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                CURRENT_DRUG_USE__Research_chemicals__2c_i__methylone__etc_: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "CURRENT DRUG USE  Research chemicals (2c-i, methylone, etc)"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [183, 2, 3, 0, 0]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                CURRENT_DRUG_USE__Anxiolytic_Benzodiazapines__Valium__Klonopin__Xanax__Librium__Ativan__etc_: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "CURRENT DRUG USE  Anxiolytic Benzodiazapines (Valium, Klonopin, Xanax, Librium, Ativan, etc)"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [136, 30, 8, 11, 4]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                CURRENT_DRUG_USE__GHB_GBL: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "CURRENT DRUG USE  GHB/GBL"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [188, 0, 0, 0, 0]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                CURRENT_DRUG_USE__Amyl_Nitrate_poppers: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "CURRENT DRUG USE  Amyl Nitrate/poppers"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [175, 6, 5, 0, 0]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                CURRENT_DRUG_USE__Ketamine: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "CURRENT DRUG USE  Ketamine"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [175, 8, 1, 3, 1]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                CURRENT_DRUG_USE__DXM_cough_syrup: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "CURRENT DRUG USE  DXM/cough syrup"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [172, 14, 2, 1, 0]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                CURRENT_DRUG_USE__Nitrous_oxide: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "CURRENT DRUG USE  Nitrous oxide"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [180, 8, 1, 0, 0]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                CURRENT_DRUG_USE__DMT: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "CURRENT DRUG USE  DMT"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [180, 5, 3, 0, 0]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                PAST_DRUG_USE__historical_maximum_use___Tobacco: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "PAST DRUG USE (historical maximum use)  Tobacco"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [26, 30, 19, 22, 96]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                PAST_DRUG_USE__historical_maximum_use___Nicotine_Vaping: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "PAST DRUG USE (historical maximum use)  Nicotine Vaping"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [83, 23, 17, 12, 54]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                PAST_DRUG_USE__historical_maximum_use___Marijuana: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "PAST DRUG USE (historical maximum use)  Marijuana"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [23, 51, 31, 38, 50]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                PAST_DRUG_USE__historical_maximum_use___Hash_or_other_marijuana_concentrates: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "PAST DRUG USE (historical maximum use)  Hash or other marijuana concentrates"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [102, 27, 17, 16, 18]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                PAST_DRUG_USE__historical_maximum_use___Cocaine: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "PAST DRUG USE (historical maximum use)  Cocaine"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [94, 41, 29, 11, 11]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                PAST_DRUG_USE__historical_maximum_use___Crack: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "PAST DRUG USE (historical maximum use)  Crack"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [156, 13, 7, 1, 2]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                PAST_DRUG_USE__historical_maximum_use___Light_sleeping_medication__antihistamines_diphenhydramine__etc__Melatonin__Valarian_root__etc_: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "PAST DRUG USE (historical maximum use)  Light sleeping medication (antihistamines diphenhydramine, etc, Melatonin, Valarian root, etc)"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [61, 48, 30, 29, 18]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                PAST_DRUG_USE__historical_maximum_use___Other_sleep_medications__Hypnotic_benzos__temazepan__nitrazepan__etc___Z_drugs__Lunesta__ambien__etc___etc_: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "PAST DRUG USE (historical maximum use)  Other sleep medications: Hypnotic benzos (temazepan, nitrazepan, etc), Z-drugs (Lunesta, ambien, etc), etc."
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [118, 33, 13, 7, 10]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                PAST_DRUG_USE__historical_maximum_use___Prescription_amphetamines: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "PAST DRUG USE (historical maximum use)  Prescription amphetamines"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [121, 18, 11, 17, 13]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                PAST_DRUG_USE__historical_maximum_use___Methamphetamine: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "PAST DRUG USE (historical maximum use)  Methamphetamine"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [145, 14, 7, 3, 6]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                PAST_DRUG_USE__historical_maximum_use___MDMA_estacy: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "PAST DRUG USE (historical maximum use)  MDMA/estacy"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [109, 36, 24, 4, 5]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                PAST_DRUG_USE__historical_maximum_use___Mushrooms: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "PAST DRUG USE (historical maximum use)  Mushrooms"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [90, 51, 35, 3, 2]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                PAST_DRUG_USE__historical_maximum_use___LSD: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "PAST DRUG USE (historical maximum use)  LSD"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [110, 36, 25, 6, 2]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                PAST_DRUG_USE__historical_maximum_use___Heroin_Opium: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "PAST DRUG USE (historical maximum use)  Heroin/Opium"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [157, 7, 0, 1, 10]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                PAST_DRUG_USE__historical_maximum_use___Kratom: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "PAST DRUG USE (historical maximum use)  Kratom"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [144, 11, 7, 7, 6]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                PAST_DRUG_USE__historical_maximum_use___Kava: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "PAST DRUG USE (historical maximum use)  Kava"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [159, 9, 7, 0, 0]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                PAST_DRUG_USE__historical_maximum_use___Gabanergics__Kratom__Phenibut__etc_: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "PAST DRUG USE (historical maximum use)  Gabanergics (Kratom, Phenibut, etc)"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [152, 9, 6, 3, 5]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                PAST_DRUG_USE__historical_maximum_use___Prescription_opiates: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "PAST DRUG USE (historical maximum use)  Prescription opiates"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [122, 25, 12, 6, 13]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                PAST_DRUG_USE__historical_maximum_use___Research_chemicals__2c_i__methylone__etc_: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "PAST DRUG USE (historical maximum use)  Research chemicals (2c-i, methylone, etc)"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [158, 11, 5, 0, 1]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                PAST_DRUG_USE__historical_maximum_use___Anxiolytic_Benzodiazapines__Valium__Klonopin__Xanax__Librium__Ativan__etc_: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "PAST DRUG USE (historical maximum use)  Anxiolytic Benzodiazapines (Valium, Klonopin, Xanax, Librium, Ativan, etc)"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [96, 35, 18, 16, 12]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                PAST_DRUG_USE__historical_maximum_use___GHB_GBL: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "PAST DRUG USE (historical maximum use)  GHB/GBL"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [169, 4, 0, 0, 1]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                PAST_DRUG_USE__historical_maximum_use___Amyl_Nitrate_poppers: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "PAST DRUG USE (historical maximum use)  Amyl Nitrate/poppers"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [154, 9, 9, 3, 1]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                PAST_DRUG_USE__historical_maximum_use___Ketamine: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "PAST DRUG USE (historical maximum use)  Ketamine"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [143, 19, 5, 3, 3]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                PAST_DRUG_USE__historical_maximum_use___DXM_cough_syrup: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "PAST DRUG USE (historical maximum use)  DXM/cough syrup"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [139, 18, 7, 7, 6]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                PAST_DRUG_USE__historical_maximum_use___Nitrous_oxide: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "PAST DRUG USE (historical maximum use)  Nitrous oxide"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [143, 19, 9, 2, 3]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                },
                PAST_DRUG_USE__historical_maximum_use___DMT: {
                    chartOptions: {
                        main: 'Drug_Use',
                        size: '6',
                        height: "auto",
                        chart: {
                            type: 'bar'
                        },
                        xAxis: {
                            categories: [`1`, `2`, `3`, `4`, `5`],
                        },
                        title: {
                            text: "PAST DRUG USE (historical maximum use)  DMT"
                        },
                        subtitle: {
                            text: `1 = No Use 2 = Rarely 3 = Social use 4 = Habitual use 5 = Addictive use`
                        },
                        series: [{
                                name: 'Count',
                                data: [154, 16, 3, 0, 2]
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    }
                }

            } //drug use
        }
    ]//charts
} //export
